import {hpcAttrs} from '@github-ui/hpc'
import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {Hero} from '@primer/react-brand/esm'

import type {GenericContent} from '../../../../brand/lib/types/contentful'

import {CtaGroup} from '../../_components/CtaGroup/CtaGroup'

type Props = {
  contentfulContent: GenericContent
}

export function HeroContent({ref, ...props}: Props & {ref?: React.Ref<HTMLDivElement>}) {
  const {contentfulContent} = props
  const {heading, subheading, ctas} = contentfulContent.fields

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <div ref={ref} className="lp-IntroHero">
      {/* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */}
      <Hero className="lp-IntroHero-hero" {...hpcAttrs()} align="center">
        {heading ? <Hero.Heading size="display">{heading}</Hero.Heading> : null}

        {subheading ? (
          <Hero.Description size="300" variant="default">
            {documentToPlainTextString(subheading)}
          </Hero.Description>
        ) : null}
      </Hero>

      {ctas ? <CtaGroup contentfulContent={ctas} location="hero" /> : null}
    </div>
  )
}
